import styled from 'styled-components';
import {transparentize} from 'polished';

export const Wrapper = styled.div`
  margin: 10px 0;
  align-items: center;
  display: flex;
`;

export const Label = styled.span`
  min-width: 20px;
  font-size: 15px;
  line-height: 20px;
  margin-right: 20px;
`;

export const Input = styled.label`
  column-gap: 10px;
  align-items: center;
  grid-template-columns: max-content minmax(100px, max-content) max-content;
  grid-auto-flow: column;
  display: inline-grid;
  
  font-size: 15px;
  color: ${({theme}) => `
    ${transparentize(.6, theme.variables.color)};
  `};  
`;

export const Range = styled.div`
  margin-right: 20px;
  max-width: 500px;
  width: 100%;
`;
